const appKey = process.env.GATSBY_APP
if (!appKey) {
  throw new Error("appKey 不能为空")
}

const title = "GGG游戏节奏联欢夜"
const desc = "多游戏IP⻬聚的⾳乐盛典,在同⼀个现场,听⻅多个世界的旋律｡"

const cdnUrl = "https://site.gcores.com"

// 外链为空时保留按钮样式但禁用跳转；填入 URL 后会自动启用。
const buttons = {
  viewOfficialWebsite: "查看官网",
}
const links = {
  gcoresOfficialWebsite: "https://www.gcores.com",
  audio8082OfficialWebsite: "https://www.8082audio.com/index.html",
  vasOfficialWebsite:
    "https://www.xiaohongshu.com/user/profile/684a82fb000000001b0188e4?xsec=",
  ticketPurchaseWebsite:
    "https://show.bilibili.com/platform/detail.html?id=1006393",
}
const media = {
  // 填入 URL 启用 Hero 视频；null 时仅显示静态 Hero。
  heroVideo: "https://site.gcores.com/assets/ggg/video.mp4?v=1",
}

module.exports = {
  appKey,
  cdnUrl,
  pageUrl: `${cdnUrl}/${appKey}/`,
  appInfo: {
    name: title,
    description: desc,
    shareTitle: title,
    shareDescription: desc,
  },
  data: {
    buttons,
    links,
    media,
  },
}
